

























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import DisabledInput from '@/components/shared/DisabledInput.vue';
import { blake2AsU8a } from '@polkadot/util-crypto/blake2';
import { encodeAddress } from '@polkadot/keyring';
import { stringToU8a, u8aConcat, hexToU8a, isHex } from '@polkadot/util';

const components = {
  DisabledInput
};

@Component({ components })
export default class extends Vue {
  private address: string = '';
  private convertedAddress: string = '';

  private mounted() {
    if (this.$route.params.data) {
      this.address = this.$route.params.data;
      this.handleAddressWatch(this.$route.params.data);
    }
  }

  @Watch('address')
  private handleAddressWatch(value: string) {
    this.convertedAddress = isHex(value) ? this.convertAddress(value) : '';
  }

  private convertAddress(input: string): string {
    const addr = hexToU8a(input);
    const data = stringToU8a('evm:');
    const res = blake2AsU8a(u8aConcat(data, addr));
    return encodeAddress(res);
  }

  get isHexAddress() {
    return isHex(this.address) ? 'Yes' : 'No';
  }
}
